import React from 'react';

function AddActivity({ color = '#335B70', ...props }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="M16.375 10.75a5.625 5.625 0 110 11.25 5.625 5.625 0 010-11.25zM8.217 2l.938 12.766 1.134-8.382h1.31l1.19 2.721H19.5v1.145c-.937-.48-2-.75-3.125-.75-1.43 0-2.758.437-3.858 1.184h-.155l-.618-.436-.523-1.195-.539 3.466A6.843 6.843 0 009.5 16.375c0 .677.098 1.331.28 1.949L9.6 19.5H8.213L7.307 7.419l-.486 2.638-.676.627H2V9.105h3.584L6.821 2h1.396zM17 13.25h-1.25v2.499l-2.5.001V17l2.5-.001V19.5H17V17h2.5v-1.25H17v-2.5z"
                fill={color}
                fillRule="evenodd"
            />
        </svg>
    );
}

export default AddActivity;
